export const IncomingCallTestIds = {
  DECLINE: 'incoming-call.decline-button',
  ANSWER: 'incoming-call.answer-button',
};
